import { Offcanvas } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Sidebar = ({ show, handleClose }) => {

    const scrollTo = (id) => {
        const element = document.getElementById(id);
        element.scrollIntoView({
            behavior: "smooth",
        });
    };

    return (
        <>
            <div>
                <Offcanvas show={show} onHide={handleClose} placement='end' className='side__bar'>
                    <Offcanvas.Header closeButton></Offcanvas.Header>
                    <Offcanvas.Body>
                        <section>
                            <div className="p-0">
                                <div className='side_navBar unClick'>
                                    <div className='about iconAdd'>
                                        <Link to="/" onClick={() => { scrollTo("home"); handleClose(); }}>Home</Link>
                                    </div>
                                    <div className='about iconAdd'>
                                        <Link to="/" onClick={() => { scrollTo("features"); handleClose(); }}>Features</Link>
                                    </div>
                                    <div className='about iconAdd'>
                                        <Link to="/" onClick={() => { scrollTo("clients"); handleClose(); }}>Our Clients</Link>
                                    </div>
                                    <div className='about iconAdd border-0'>
                                        <Link to="/" onClick={() => { scrollTo("contact"); handleClose(); }}>Contact Us</Link>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </Offcanvas.Body>
                </Offcanvas>
            </div>
        </>
    );
};

export default Sidebar;